(() => {
  'use strict';
  const root = () => window.Shopify?.routes?.root || '/';
  const dialog = () => document.getElementById('LuxCartDialog');
  let lastCartTrigger;
  let cartBusy = false;
  const openCart = (trigger) => {
    const bag = dialog();
    if (!bag?.showModal) { window.location.assign(`${root()}cart`); return; }
    if (!bag.open) { lastCartTrigger = trigger || document.activeElement; bag.showModal(); }
    document.documentElement.classList.add('lux-cart-is-open');
    bag.querySelector('[data-lux-cart-close]')?.focus();
  };
  const closeCart = () => {
    dialog()?.close();
    document.documentElement.classList.remove('lux-cart-is-open');
    if (lastCartTrigger?.isConnected) lastCartTrigger.focus();
  };
  const renderCart = (sections) => {
    const html = sections?.['lux-home-cart'];
    if (!html) throw new Error('Your bag was updated. Open the full bag to view it.');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.querySelector('[data-lux-cart-body]');
    const current = dialog()?.querySelector('[data-lux-cart-body]');
    if (!incoming || !current) throw new Error('Your bag was updated. Open the full bag to view it.');
    current.replaceWith(incoming);
    document.querySelectorAll('[data-lux-cart-count]').forEach((count) => { count.textContent = incoming.dataset.count; });
  };
  const postCart = async (path, payload) => {
    const response = await fetch(`${root()}cart/${path}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...payload, sections: ['lux-home-cart'], sections_url: window.location.pathname }) });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This item could not be updated. Please check your bag.');
    return data;
  };
  const selectVariant = (input) => {
    const section = input.closest('.shopify-section');
    if (!section) return;
    const image = section.querySelector('[data-lux-model-image]');
    if (image) { image.src = input.dataset.image; image.alt = `Synapse Hub ${input.dataset.model} wireless adapter`; }
    const label = section.querySelector('[data-lux-add-label]');
    if (label) label.textContent = `Add to bag — ${input.dataset.price}`;
    const note = section.querySelector('[data-lux-model-note]');
    if (note) note.textContent = input.dataset.model.startsWith('Ultimate') ? 'Includes screen mirroring on compatible phones. Use video only while parked. Some apps restrict mirroring.' : 'Both models require factory wired CarPlay. Check compatibility before ordering.';
  };
  const initialize = (scope = document) => scope.querySelectorAll('[data-lux-variant]:checked').forEach(selectVariant);
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('change', (event) => { if (event.target.matches('[data-lux-variant]')) selectVariant(event.target); });
  document.addEventListener('click', async (event) => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-lux-menu]')) {
      const menu = document.getElementById('LuxMobileNav');
      const expanded = target.getAttribute('aria-expanded') !== 'true';
      target.setAttribute('aria-expanded', String(expanded)); target.setAttribute('aria-label', expanded ? 'Close menu' : 'Open menu'); menu.hidden = !expanded;
    }
    if (target.closest('#LuxMobileNav') && target.tagName === 'A') {
      document.getElementById('LuxMobileNav').hidden = true;
      const toggle = document.querySelector('[data-lux-menu]'); toggle?.setAttribute('aria-expanded', 'false'); toggle?.setAttribute('aria-label', 'Open menu');
    }
    if (target.matches('[data-lux-cart-open]')) {
      event.preventDefault(); openCart(target);
      if (cartBusy) return;
      cartBusy = true;
      try {
        const url = new URL(window.location.href); url.searchParams.set('sections', 'lux-home-cart');
        const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error();
        renderCart(await response.json());
        if (dialog().open) dialog().querySelector('[data-lux-cart-close]')?.focus();
      } catch {
        const status = dialog()?.querySelector('[data-lux-cart-status]');
        if (status) { status.textContent = 'Could not refresh your bag. '; const link = document.createElement('a'); link.href = `${root()}cart`; link.textContent = 'View the full bag'; status.append(link); }
      }
      finally { cartBusy = false; }
    }
    if (target.matches('[data-lux-cart-close]')) closeCart();
    if (target.matches('[data-lux-cart-change]')) {
      if (cartBusy) return;
      cartBusy = true;
      const bag = dialog(); bag.setAttribute('aria-busy', 'true');
      bag.querySelectorAll('[data-lux-cart-change], button[name="checkout"]').forEach((button) => { button.disabled = true; });
      const key = target.dataset.key;
      try {
        const data = await postCart('change', { id: key, quantity: Number(target.dataset.quantity) });
        renderCart(data.sections);
        const replacement = [...bag.querySelectorAll('[data-lux-cart-change]')].find((button) => button.dataset.key === key);
        (replacement || bag.querySelector('[data-lux-cart-close]'))?.focus();
        bag.querySelector('[data-lux-cart-status]').textContent = 'Bag updated.';
      } catch (error) { bag.querySelector('[data-lux-cart-status]').textContent = `${error.message} If your connection dropped, check the full bag before trying again.`; }
      finally { cartBusy = false; bag.removeAttribute('aria-busy'); bag.querySelectorAll('[data-lux-cart-change], button[name="checkout"]').forEach((button) => { button.disabled = false; }); }
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (form.matches('[data-lux-compatibility]')) {
      event.preventDefault();
      const values = new FormData(form); const wired = values.get('wired'); const phone = values.get('phone');
      const result = form.querySelector('[data-lux-compat-result]'); const link = form.querySelector('[data-lux-compat-shop]');
      result.hidden = false; link.hidden = true;
      if (wired === 'no') result.textContent = 'This adapter is not the right fit. Synapse Hub needs factory wired CarPlay and cannot add it to a car without it.';
      else if (wired === 'unsure' || phone === 'unsure') result.textContent = 'Let’s confirm before you order. Contact our team with your car make, model, year and phone model. A USB port by itself does not confirm compatibility.';
      else { result.textContent = phone === 'iphone' ? 'Your setup meets the basic requirements for wireless CarPlay. Both models offer it. Vehicle-specific exceptions may apply; contact us if you are unsure.' : 'Your setup meets the basic requirements. Your Android phone also needs wireless Android Auto support and 5 GHz Wi-Fi. Vehicle and phone exceptions may apply; confirm with our team if unsure.'; link.hidden = false; }
    }
    if (!form.matches('[data-lux-add]')) return;
    event.preventDefault();
    if (cartBusy || form.dataset.busy) return;
    const fields = new FormData(form); const id = fields.get('id'); if (!id) return;
    const button = form.querySelector('button[type="submit"]'); const status = form.querySelector('[data-lux-form-status]');
    form.dataset.busy = 'true'; cartBusy = true; button.disabled = true; button.setAttribute('aria-busy', 'true'); status.textContent = 'Adding to your bag…';
    try {
      const result = await postCart('add', { items: [{ id: Number(id), quantity: Number(fields.get('quantity') || 1) }] });
      renderCart(result.sections); status.textContent = 'Added to your bag.'; openCart(button);
    } catch (error) {
      status.textContent = `${error.message} Check your bag before trying again if your connection was interrupted. `;
      const link = document.createElement('a'); link.href = `${root()}cart`; link.textContent = 'View bag'; status.append(link);
    } finally { delete form.dataset.busy; cartBusy = false; button.disabled = false; button.removeAttribute('aria-busy'); }
  });
  window.addEventListener('pageshow', async (event) => {
    if (!event.persisted || cartBusy) return;
    try {
      const url = new URL(window.location.href); url.searchParams.set('sections', 'lux-home-cart');
      const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (response.ok) renderCart(await response.json());
    } catch { /* Opening the bag refreshes again and provides a full-cart fallback. */ }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { const menu = document.getElementById('LuxMobileNav'); if (menu && !menu.hidden) { menu.hidden = true; const toggle = document.querySelector('[data-lux-menu]'); toggle?.setAttribute('aria-expanded', 'false'); toggle?.setAttribute('aria-label', 'Open menu'); toggle?.focus(); } }
  });
  dialog()?.addEventListener('close', () => { document.documentElement.classList.remove('lux-cart-is-open'); if (lastCartTrigger?.isConnected) lastCartTrigger.focus(); });
  dialog()?.addEventListener('click', (event) => { if (event.target === dialog()) { const rect = dialog().getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCart(); } });
})();
